import type {CountryCode} from '@commercial-website/data-layer/locale'
import flagAT from '@commercial-website/icons/assets/flags-legacy/flag-at.svg'
import flagBE from '@commercial-website/icons/assets/flags-legacy/flag-be.svg'
import flagDE from '@commercial-website/icons/assets/flags-legacy/flag-de.svg'
import flagDK from '@commercial-website/icons/assets/flags-legacy/flag-dk.svg'
import flagEE from '@commercial-website/icons/assets/flags-legacy/flag-ee.svg'
import flagES from '@commercial-website/icons/assets/flags-legacy/flag-es.svg'
import flagFI from '@commercial-website/icons/assets/flags-legacy/flag-fi.svg'
import flagFR from '@commercial-website/icons/assets/flags-legacy/flag-fr.svg'
import flagGB from '@commercial-website/icons/assets/flags-legacy/flag-gb.svg'
import flagIE from '@commercial-website/icons/assets/flags-legacy/flag-ie.svg'
import flagIT from '@commercial-website/icons/assets/flags-legacy/flag-it.svg'
import flagLU from '@commercial-website/icons/assets/flags-legacy/flag-lu.svg'
import flagNL from '@commercial-website/icons/assets/flags-legacy/flag-nl.svg'
import flagNO from '@commercial-website/icons/assets/flags-legacy/flag-no.svg'
import flagPT from '@commercial-website/icons/assets/flags-legacy/flag-pt.svg'
import flagSE from '@commercial-website/icons/assets/flags-legacy/flag-se.svg'
import flagUS from '@commercial-website/icons/assets/flags-legacy/flag-us.svg'

export const countryFlags: Record<CountryCode, string> = {
    gb: flagGB,
    us: flagUS,
    dk: flagDK,
    ee: flagEE,
    es: flagES,
    fr: flagFR,
    de: flagDE,
    se: flagSE,
    ie: flagIE,
    at: flagAT,
    fi: flagFI,
    be: flagBE,
    nl: flagNL,
    it: flagIT,
    pt: flagPT,
    no: flagNO,
    lu: flagLU,
}
